const INLINE_SRC = "https://js.paystack.co/v2/inline.js";
const LOAD_TIMEOUT_MS = 8000;

let loader = null;

export const loadPaystackInline = () => {
  if (typeof window === "undefined") return Promise.reject(new Error("No browser context"));
  if (window.PaystackPop) return Promise.resolve(window.PaystackPop);
  if (loader) return loader;

  loader = new Promise((resolve, reject) => {
    const script = document.createElement("script");

    script.src = INLINE_SRC;
    script.async = true;

    script.onload = () => {
      if (window.PaystackPop) {
        resolve(window.PaystackPop);

        return;
      }

      loader = null;
      reject(new Error("Paystack inline did not initialise"));
    };

    script.onerror = () => {
      loader = null;
      reject(new Error("Paystack inline could not be loaded"));
    };

    document.head.appendChild(script);
  });

  return loader;
};

export const resumeInlineTransaction = (PaystackPop, accessCode) =>
  new Promise((resolve) => {
    let settled = false;
    let timer = null;

    const once = (outcome) => {
      if (settled) return;

      settled = true;
      clearTimeout(timer);
      resolve(outcome);
    };

    const popup = new PaystackPop();

    timer = setTimeout(() => {
      try {
        popup.cancelTransaction?.();
      } catch {
        /* the surface never opened */
      }

      once("stalled");
    }, LOAD_TIMEOUT_MS);

    popup.resumeTransaction(accessCode, {
      onLoad: () => clearTimeout(timer),
      onSuccess: () => once("success"),
      onCancel: () => once("cancelled"),
      onError: () => once("error"),
    });
  });
